import { createFileRoute, useParams } from "@tanstack/react-router";

import { EmployeeProfilePage } from "@/components/pages/EmployeeProfilePage";
import {
  isProfileTabParam,
  type ProfileTabParam,
} from "@/lib/people-profile-tabs";

interface EmployeeProfileSearch {
  tab?: ProfileTabParam;
}

export const Route = createFileRoute("/_authenticated/people/$userId/")({
  validateSearch: (search: Record<string, unknown>): EmployeeProfileSearch => ({
    tab: isProfileTabParam(search.tab) ? search.tab : undefined,
  }),
  component: EmployeeProfileRoute,
});

function EmployeeProfileRoute() {
  const { userId } = useParams({ from: "/_authenticated/people/$userId/" });
  const { tab } = Route.useSearch();
  return <EmployeeProfilePage userId={userId} tab={tab} />;
}
